import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Martin Heberling's Personal Website</h1>
        <p>Coming soon...</p>
      </header>
    </div>
  );
}

export default App;
